<ng-template #wtModal>
  <div class="wt-modal" [ngClass]="additionalClasses" [class.wt-modal--with-close]="showCloseButton">
    <div *ngIf="showCloseButton" class="wt-modal__close-button" (click)="onCloseButtonClick()"></div>
    <ng-content></ng-content>
  </div>
</ng-template>
